// Design tokens for the "Autonomy" visual language used by the AI-led Home
// page — a dark teal canvas with scarce electric-green/cyan accents. This
// diverges from the site-wide `loadsmart` theme, so it lives as its own file.
export const homeColor = {
  bg: '#071318',
  bg2: '#08171D',
  surface: '#0E2A31',
  surface2: '#0A222A',
  carbon: 'rgba(255,255,255,.08)',
  line: 'rgba(20,214,77,.16)',
  line2: 'rgba(20,214,77,.34)',
  green: '#14D64D',
  cyan: '#00D7D7',
  lime: '#84F11E',
  amber: '#F5B544',
  white: '#EAF4F1',
  muted: '#9DB4B2',
  muted2: '#6C8583',
  ink: '#06231C',
};

export const homeWrap = '1160px';
